module.exports = __webpack_public_path__ + "img/board-star-2nd.6d6bbb7b.svg";